import { render } from "./CajaDetalle.vue?vue&type=template&id=78f88f9f&scoped=true"
import script from "./CajaDetalle.vue?vue&type=script&lang=js"
export * from "./CajaDetalle.vue?vue&type=script&lang=js"

import "./CajaDetalle.vue?vue&type=style&index=0&id=78f88f9f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f88f9f"]])

export default __exports__